module.exports = __webpack_public_path__ + "img/logo-dhec.d2ce412c.svg";